export * from './lib/shared-feature-warning-bars.module';
export * from './lib/warning-bar/warning-bar.component';
